<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 旗下用户
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form :model="query" ref="query" label-width="80px" inline="">
                    <el-form-item label="用户昵称:" label-width="75px">
                        <el-input v-model="query.nickname" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch()">重置</el-button>
                </el-form>
            </div>
            
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
             
            >
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="nickname" label="用户昵称"  align="center"></el-table-column>
                <el-table-column prop="sex" label="性别"  align="center"></el-table-column>
                <el-table-column prop="headimgurl" label="用户头像"  align="center">
                            <template slot-scope="scope">
                            <el-image
                                class="table-td-thumb"
                                :src="scope.row.headimgurl"
                                :preview-src-list="[scope.row.headimgurl]"
                            ></el-image>
                        </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间"  align="center" width="200px"></el-table-column>
                <el-table-column prop="employ_id" label="所属员工id"  align="center"></el-table-column>
                <el-table-column prop="fincpy_id" label="所属财务公司id"  align="center"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>


import { post } from '../../../api/request';

export default {
    name: 'basetable',
    data() {
        return {
            userList:[],
            fiList:[],
            //编辑数据
            editVisible:false,
            editForm:{},
            editForm1:{},
            editVisible1:false,
            companyid:'',//当前公司id
            //搜索数据
            tableData: [],
            query: {
                nickname: '',
                pageIndex: 1,
                pageSize: 8
            },
            pageTotal: 0,
            //批量删除
            multipleSelection: [],
            delList: [],
            //获取id
            idx: -1,
            id: -1,
           
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
         this.id =  sessionStorage.getItem('userid')
        this.getData()
        
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
         this.id =  sessionStorage.getItem('userid')
        this.getData()
        
    },
    
    methods: {
        //重置搜索
        resetsearch(){
            this.query.nickname= '',
            this.getData()
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('id',this.id)
            formdata.append('nickname',this.query.nickname)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            post('admin/user/finUser',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData()
                    }
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        // 触发搜索按钮
        inputSearch(){
            let formdata = new FormData()
            formdata.append('id',this.id)
            formdata.append('nickname',this.query.nickname)
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            post('admin/user/finUser',formdata).then(res => {
                if(res.data.data.list){
                    this.tableData = res.data.data.list
                     this.pageTotal = res.data.data.num
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}
</style>
